// Banco do aparelho (IndexedDB), um para cada usuário. Guarda as tabelas das
// empresas dele, para o app funcionar sem sinal, e a fila do que foi feito no
// aparelho e ainda não chegou ao servidor.
import { deleteDB, openDB } from 'idb';

// Tabelas que o aparelho guarda. A ordem é a da baixa: cadastros antes da
// operação.
export const TABELAS = [
  'categorias', 'veiculos', 'licencas', 'colaboradores', 'regras_remuneracao', 'clientes',
  'contas_fixas', 'acertos', 'viagens', 'fretes', 'entregas', 'lancamentos', 'parcelas', 'anexos', 'oficinas', 'manutencao_itens',
  'viagem_eventos',
];

// 1: cadastros (E3) · 2: viagens, cargas e lançamentos (E4)
// 3: despesas, parcelas, contas fixas, anexos e os arquivos das fotos (E5)
// 4: acertos (E6) · 5: oficinas de confiança (app do motorista)
// 6: manutenção preventiva (o plano de cada caminhão)
// 7: entregas no caminho (as paradas de cada carga)
// 8: os eventos da viagem (modo viagem)
const VERSAO = 8;
let banco = null;
let nomeAtual = null;
let dono = null;

export function nomeDoBanco(usuarioId) {
  return `maxcargo-${usuarioId}`;
}

// Usuário de quem é o banco aberto agora.
export function donoDoBanco() {
  return banco ? dono : null;
}

export async function abrirBanco(usuarioId) {
  const nome = nomeDoBanco(usuarioId);
  if (banco && nomeAtual === nome) return banco;
  fecharBanco();
  dono = usuarioId;
  banco = await openDB(nome, VERSAO, {
    upgrade(db, versaoAntiga, _versaoNova, transacao) {
      for (const tabela of TABELAS) {
        if (db.objectStoreNames.contains(tabela)) continue;
        const store = db.createObjectStore(tabela, { keyPath: 'id' });
        store.createIndex('empresa_id', 'empresa_id');
      }
      if (versaoAntiga < 1) {
        // { empresa_id, papel, empresa } — as contas de que o usuário participa
        db.createObjectStore('vinculos', { keyPath: 'empresa_id' });
        // { seq, empresa_id, tabela, tipo, registro_id, dados, estado, erro, tentado, criada_em }
        const fila = db.createObjectStore('fila', { keyPath: 'seq', autoIncrement: true });
        fila.createIndex('registro', ['tabela', 'registro_id']);
        // { chave, valor } — por exemplo, quando cada empresa foi baixada
        db.createObjectStore('meta', { keyPath: 'chave' });
      } else {
        // Tabelas novas: cada empresa precisa ser baixada de novo antes de
        // o app confiar no que está no aparelho. A fila fica como está.
        transacao.objectStore('meta').delete(IDBKeyRange.bound('baixado:', 'baixado:\uffff'));
      }
      if (!db.objectStoreNames.contains('arquivos')) {
        // { id (do anexo), empresa_id, caminho, mime, bytes, sha256, blob, enviado }
        // — a foto fica aqui até subir para o servidor (e depois, para abrir sem sinal)
        db.createObjectStore('arquivos', { keyPath: 'id' });
      }
    },
    // Outra aba quer apagar ou atualizar o banco: solta a conexão.
    blocking() {
      fecharBanco();
    },
    terminated() {
      banco = null;
      nomeAtual = null;
    },
  });
  nomeAtual = nome;
  return banco;
}

export function bancoAberto() {
  if (!banco) throw new Error('BANCO_LOCAL: o banco do aparelho não está aberto');
  return banco;
}

export function temBanco() {
  return banco !== null;
}

export function fecharBanco() {
  banco?.close();
  banco = null;
  nomeAtual = null;
}

export async function apagarBanco(usuarioId) {
  fecharBanco();
  await deleteDB(nomeDoBanco(usuarioId));
}

export async function lerMeta(chave) {
  return (await bancoAberto().get('meta', chave))?.valor ?? null;
}

export async function gravarMeta(chave, valor) {
  await bancoAberto().put('meta', { chave, valor });
}
